import script from "./PageNotFound.vue?vue&type=script&lang=ts&setup=true"
export * from "./PageNotFound.vue?vue&type=script&lang=ts&setup=true"

import "./PageNotFound.vue?vue&type=style&index=0&id=da20da4e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-da20da4e"]])

export default __exports__